
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"280","height":"249","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M202.844 28.297L186.77 1.507l-.858.514 15.865 26.442a5.064 5.064 0 00-3.545 3.483L66.915 1.048l-.23.973 131.368 30.91a5.102 5.102 0 00.402 2.428l-43.869 28.649a4.042 4.042 0 10.565.825l43.794-28.6a5.046 5.046 0 004.144 2.162c.772 0 1.504-.174 2.159-.484l26.376 128.114a5.053 5.053 0 00-3.263 5.091l-87.833 44.553a4.04 4.04 0 10-3.115 6.617 4.042 4.042 0 003.655-5.769l87.474-44.371a5.066 5.066 0 003.111 3.352l-9.367 73.058.992.128 9.351-72.934a5.052 5.052 0 004.762-8.093l41.93-21.269-.453-.891-42.2 21.406a5.043 5.043 0 00-2.167-1.079L279.833.264 278.868 0l-45.371 165.705-.062-.001h-.034a5.01 5.01 0 00-.809.065l-26.437-128.41a5.044 5.044 0 001.986-4.016c0-.965-.271-1.866-.739-2.633L253.145.837 252.598 0l-45.801 29.911a5.04 5.04 0 00-3.953-1.614zM34.527 20.682l-.067.014-1.599.35-.214-.976 1.533-.336 1.302-.687.467.885-1.362.718-.06.032zm3.679-3.072l2.724-1.436.467.884-2.724 1.437-.467-.885zm-11.954 3.861l3.198-.7.214.976-3.198.701-.214-.977zm17.402-6.734l2.724-1.437.466.885-2.724 1.436-.466-.884zm-23.798 8.136l3.198-.7.214.976-3.198.701-.214-.977zm29.246-11.01l2.724-1.436.466.884-2.724 1.437-.466-.885zM13.46 24.275l3.197-.701.215.977-3.198.7-.214-.976zM54.55 8.99l2.724-1.437.466.885-2.724 1.436-.466-.884zM8.004 25.47l2.259-.494.214.977-2.4.525a4.042 4.042 0 11-.073-1.007zM59.998 6.117l2.724-1.436.466.884-2.724 1.437-.466-.885zm5.447-2.873l1.362-.719.467.885-1.362.718-.467-.884z","fill":"#fff"}})])
          )
        }
      }
    